import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* stylelint-disable no-descending-specificity */


import React from 'react';
import { white, gray10, gray25, gray40, gray75, gray90 } from '@spotify-internal/encore-foundation';
import { css } from 'styled-components';
import { Button } from "../Button";
import { buttonHover, buttonSizes } from "../../styles/mixins/buttons";

var isDarkTheme = function isDarkTheme(props) {
  var _props$theme;

  return ((_props$theme = props.theme) == null ? void 0 : _props$theme.button) === 'dark';
};

var borderStyle = '1.12pt solid';

var color = function color(props) {
  return isDarkTheme(props) ? white : gray10;
};

var border = function border(props) {
  return isDarkTheme(props) ? gray75 : gray75;
};

var background = function background(props) {
  return isDarkTheme(props) ? 'rgba(24, 24, 24, 0.7)' : 'rgba(255, 255, 255, 0.3)';
};

var colorHover = function colorHover(props) {
  return isDarkTheme(props) ? white : gray10;
};

var borderHover = function borderHover(props) {
  return isDarkTheme(props) ? white : gray10;
};

var colorActive = function colorActive(props) {
  return isDarkTheme(props) ? gray75 : gray40;
};

var borderActive = function borderActive(props) {
  return isDarkTheme(props) ? gray40 : gray75;
};

var colorFocus = function colorFocus(props) {
  return isDarkTheme(props) ? gray90 : gray25;
};

var hoverStyles = function hoverStyles() {
  return css(["", ";border:", " ", ";color:", ";"], buttonHover(), borderStyle, borderHover, colorHover);
};

var focusStyles = function focusStyles() {
  return css(["border:", " ", ";color:", ";"], borderStyle, borderActive, colorFocus);
};

var activeStyles = function activeStyles() {
  return css(["transform:scale(1);border:", " ", ";color:", ";"], borderStyle, borderActive, colorActive);
};

var buttonStroked = css(["background-color:", ";border:", " ", ";color:", ";position:relative;line-height:0.8;&:hover:not(:focus):not(:disabled){", ";}", ";&:focus{", ";}", ";&:active{&,&:hover{", ";}}", ";&[disabled],fieldset[disabled] &{background-color:transparent;box-shadow:", " ", ";color:", ";cursor:not-allowed;opacity:0.4;}"], background, borderStyle, border, color, hoverStyles(), function (props) {
  return props.hover && css(["", ";"], hoverStyles());
}, focusStyles(), function (props) {
  return props.focus && css(["", ";"], focusStyles());
}, activeStyles(), function (props) {
  return props.active && css(["", ";"], activeStyles());
}, borderStyle, borderActive, color);
var ButtonComponent = React.forwardRef(function (props, ref) {
  return React.createElement(Button, Object.assign({}, props, {
    condensed: false,
    variantRules: buttonStroked,
    ref: ref
  }));
});

var buttonHelpers = _objectSpread({}, buttonSizes, {
  darkTheme: {
    button: 'dark'
  },
  displayName: 'ButtonSecondary'
});

export var ButtonSecondary = Object.assign(ButtonComponent, buttonHelpers);
export default ButtonSecondary;